// BASIC:
import React from "react"
import "./styles/me.styles.sass"
import Img from "gatsby-image"

// MEDIA:

// UTILITIES:
import { graphql } from "gatsby"
import AliceCarousel from "react-alice-carousel"
import { Container, Row, Col } from "react-bootstrap"

// COMPONENTS:
import Layout from "../components/layout"
import SEO from "../components/seo"
import SocialLinksNav from "../components/social-links-nav/social-links-nav.comp"

// PAGE COMPONENT=>
const Me = ({ data, location }) => {
  // set more about section images:
  const ChessBoard = data.chess.childImageSharp.fluid
  const Arduino = data.arduino.childImageSharp.fluid
  const WoodCraft = data.woodCraft.childImageSharp.fluid

  // set salih slider images:
  const Salih0 = data.salih0.childImageSharp.fluid
  const Salih1 = data.salih1.childImageSharp.fluid
  const Salih2 = data.salih2.childImageSharp.fluid
  const Salih3 = data.salih3.childImageSharp.fluid
  const Salih4 = data.salih4.childImageSharp.fluid
  const Salih5 = data.salih5.childImageSharp.fluid
  const Salih6 = data.salih6.childImageSharp.fluid
  const Salih7 = data.salih7.childImageSharp.fluid
  // const Salih8 = data.salih8.childImageSharp.fluid

  const salihImgs = [
    <Img fluid={Salih0} className="salih-img" />,
    <Img fluid={Salih1} className="salih-img" />,
    <Img fluid={Salih2} className="salih-img" />,
    <Img fluid={Salih3} className="salih-img" />,
    <Img fluid={Salih4} className="salih-img" />,
    <Img fluid={Salih5} className="salih-img" />,
    <Img fluid={Salih6} className="salih-img" />,
    <Img fluid={Salih7} className="salih-img" />,
    // <Img fluid={Salih8} className="salih-img" />,
    <Img fluid={Salih0} className="salih-img" />,
  ]

  const responsive = {
    0: { items: 0 },
    200: { items: 1 },
    400: { items: 1 },
  }

  return (
    <Layout location={location}>
      <SEO title="Ahmad Salih" />
      <Container>
        <div className="me-page-wrapper">
          <section className="first-things-first">
            <div className="imgs-wrapper x-screen">
              <div className="salih-imgs">
                <AliceCarousel
                  autoPlay
                  autoPlayStrategy="none"
                  autoPlayInterval={6000}
                  animationDuration={1000}
                  animationType="slide"
                  infinite
                  touchTracking={false}
                  disableDotsControls
                  disableButtonsControls
                  items={salihImgs}
                  responsive={responsive}
                />
              </div>
              <small>{`{ ...Dreams, Muslim, Software engineer, Frontend, Geek, Bugs dealer, Backend can center DIVs well }`}</small>
            </div>
            <Row>
              <Col lg={8} xs={12}>
                <div className="salih-txt">
                  <h1>Ahmad A. Salih</h1>
                  <p classNme="title">Software Engineer</p>
                  <p>
                    Hi, Thanks for visiting my site! Below you can find more information about me. And if you need
                    anything else please just drop me a line on{" "}
                    <a href="mailTo:Ahmadsalihdev@gmail.com">
                      <b>Email</b>
                    </a>{" "}
                    or {""}
                    <a
                      href="https://twitter.com/messages/compose?recipient_id=1152595255943991296&ref_src=twsrc%5Etfw"
                      className="twitter-dm-button"
                      data-url="https://salih.netlify.com/writing"
                      data-via="salihcodev"
                      data-lang="en"
                      data-dnt="true"
                      data-screen-name="https://twitter.com/salihcodev"
                      data-show-count="false"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <b>Twitter DM</b>
                    </a>
                  </p>
                  {/* inject social nav links */}
                  <SocialLinksNav />
                  <a
                    className="preview-resume"
                    href="https://github.com/salihcodev/salih_CV/raw/only/base/Ahmad_Salih_CV.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Download CV
                  </a>
                </div>
              </Col>
              <Col lg={4} xs={12}>
                <div className="imgs-wrapper">
                  <div className="salih-imgs">
                    <AliceCarousel
                      autoPlay
                      autoPlayStrategy="none"
                      autoPlayInterval={6000}
                      animationDuration={1000}
                      animationType="slide"
                      infinite
                      touchTracking={false}
                      disableDotsControls
                      disableButtonsControls
                      items={salihImgs}
                      responsive={responsive}
                    />
                  </div>
                  <small>{`{ ...Dreams, Muslim, Software engineer, Frontend, Geek, Bugs dealer, Backend can center DIVs well }`}</small>
                </div>
              </Col>
            </Row>
          </section>
          <section className="intro">
            <article>
              <p>
                I’m a general software engineer who usually uses the MERN Stack with experience in the front-end, in the
                back-end, not only but also gained some experience in mobile applications development (not big exp. but
                willing to build experience). All this in various languages and technologies like ES6+ and (Typescript),
                Reactjs, React Native, Nodejs, MongoDB, Expressjs, Sass.
              </p>
              <p>
                <em>
                  <b>Recently I found a new interest, Golang</b>
                </em>
              </p>
              <p>
                — But mainly I’m working as a Frontend developer. Who built a lot of web applications using web
                technologies like Bootstrap (react-bootstrap), Reactjs, Gatsbyjs, Gulp, Pug/Jade, Sass, Ajax, Webpack
              </p>

              <p>
                One of the other technologies I used before is Docker and built some simple CI/CD pipelines with the
                help of Circles, Travis also Github actionsis
              </p>
            </article>
          </section>
          <section className="achieve-and-picked">
            <Row>
              <Col lg={8} md={7} xs={12}>
                <p className="achieve"></p>
                <p></p>
              </Col>
              <Col lg={4} md={5} xs={12}>
                <div className="picked-achievements">
                  <img src="" alt="upwork-logo" />
                </div>
              </Col>
            </Row>
          </section>
          <section className="highlight">
            <p>
              <em>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil culpa odio tempore doloribus sapiente.
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil culpa odio tempore doloribus
                sapiente.Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil culpa odio tempore doloribus
                sapiente.
              </em>
            </p>
          </section>
          <section className="more-about-me">
            <h2 className="heading">Some extras about me</h2>
            <div className="more-about-container">
              <p>
                I love to learn everything and anything, Trying new things fell me i'm alive!
                <br />
                Specially the new things come with new challenges.
              </p>
              <Row>
                <Col md={7} xs={12}>
                  <div className="txt">
                    <ul>
                      <li>
                        <p>
                          <strong>Playing chess</strong> My favorite game.
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>Arduino</strong> I like to build stupid peaces of arduino. lol
                        </p>
                      </li>
                      <li>
                        <p>
                          <strong>Wood Craft</strong> Crafting woods is awesome for making me feel satisfied.
                        </p>
                      </li>
                    </ul>
                  </div>
                </Col>
                <Col md={5} xs={12}>
                  <div className="imgs">
                    <Img className="more-about-img" fluid={ChessBoard} />
                    <Img className="more-about-img" fluid={Arduino} />
                    <Img className="more-about-img" fluid={WoodCraft} />
                  </div>
                </Col>
              </Row>
            </div>
          </section>
        </div>
      </Container>
    </Layout>
  )
}

export default Me
export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    chess: file(absolutePath: { regex: "/chess-board.jpg/" }) {
      childImageSharp {
        fluid(quality: 70) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    arduino: file(absolutePath: { regex: "/arduino.jpeg/" }) {
      childImageSharp {
        fluid(quality: 70) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    woodCraft: file(absolutePath: { regex: "/wood-craft.jpg/" }) {
      childImageSharp {
        fluid(quality: 70) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    salih0: file(absolutePath: { regex: "/salih0-min.jpg/" }) {
      childImageSharp {
        fluid(quality: 80) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    salih1: file(absolutePath: { regex: "/salih1-min.jpg/" }) {
      childImageSharp {
        fluid(quality: 80) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    salih2: file(absolutePath: { regex: "/salih2-min.jpg/" }) {
      childImageSharp {
        fluid(quality: 80) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    salih3: file(absolutePath: { regex: "/salih3-min.jpg/" }) {
      childImageSharp {
        fluid(quality: 80) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    salih4: file(absolutePath: { regex: "/salih4-min.jpg/" }) {
      childImageSharp {
        fluid(quality: 80) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    salih5: file(absolutePath: { regex: "/salih5-min.jpg/" }) {
      childImageSharp {
        fluid(quality: 80) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    salih6: file(absolutePath: { regex: "/salih6-min.jpg/" }) {
      childImageSharp {
        fluid(quality: 80) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    salih7: file(absolutePath: { regex: "/salih7-min.jpg/" }) {
      childImageSharp {
        fluid(quality: 80) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    salih8: file(absolutePath: { regex: "/salih8-min.jpg/" }) {
      childImageSharp {
        fluid(quality: 80) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
